const NotFound = () => {
    return <h1 style={{ fontSize: 80 }} className="text-orange-1 text-center fw-700">404, Page Not Found!</h1>;
};

export default NotFound;
